export default "__VITE_ASSET__df3457c5__"